import { CloseCircleOutlined, EditOutlined } from '@ant-design/icons';
import { AutomationStatus } from '@repo/utils';
import { Button } from 'antd';
import { AUTOMATION_CANVAS_PATH } from 'automations/data/paths';
import useAutomationId from 'automations/hooks/useAutomationId';
import {
  automationStatusSelector,
  isLiveEditEnabledSelector,
  isReportModeSelector,
} from 'automations/selectors/automationConfig';
import { setAutomationMode } from 'automations/store/automationConfigSlice';
import { AutomationMode } from 'automations/types/automation';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

export default function LiveEdit() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const automationId = useAutomationId();
  const automationStatus = useSelector(automationStatusSelector);
  const isLiveEditEnabled = useSelector(isLiveEditEnabledSelector);
  const inReportMode = useSelector(isReportModeSelector);

  const handleEnterLiveEdit = useCallback(() => {
    if (inReportMode) {
      // navigate to automation canvas with live edit preset
      navigate(`${AUTOMATION_CANVAS_PATH(automationId)}?preset=${AutomationMode.liveEdit}`);
    } else {
      dispatch(setAutomationMode(AutomationMode.liveEdit));
    }
  }, [automationId, dispatch, inReportMode, navigate]);

  const handleExitLiveEdit = useCallback(() => {
    dispatch(setAutomationMode(AutomationMode.default));
    navigate(AUTOMATION_CANVAS_PATH(automationId));
  }, [automationId, dispatch, navigate]);

  if (!automationStatus || automationStatus !== AutomationStatus.published || inReportMode) return null;

  if (isLiveEditEnabled) {
    return (
      <Button
        size="large"
        type="default"
        onClick={handleExitLiveEdit}
        icon={<CloseCircleOutlined />}
      >
        Exit Live Edit
      </Button>
    );
  } else {
    return (
      <Button
        icon={<EditOutlined />}
        size="large"
        onClick={handleEnterLiveEdit}
      >
        Live Edit
      </Button>
    );
  }
}
